import React, { useEffect, useState } from 'react';
import { Select, Typography } from 'antd';
import './styles.css';
const { Option } = Select;
interface IGaugeChartComponentProps {
    gaugeValues: {
        potentialValue: number;
        projectSum: number;
    };
    yearsAnalysis: number[];
    yearsProjects: number[];
    setYearAnalysisSelected: React.Dispatch<React.SetStateAction<number | undefined>>;
    setYearProjectsSelected: React.Dispatch<React.SetStateAction<number | undefined>>;
    yearAnalysisSelected: number | undefined;
    yearProjectsSelected: number | undefined;
}
export default function GaugeChartComponent({
    gaugeValues,
    yearsAnalysis,
    yearsProjects,
    setYearAnalysisSelected,
    setYearProjectsSelected,
    yearAnalysisSelected,
    yearProjectsSelected,
}: IGaugeChartComponentProps) {
    const [percentageProjects, setPercentageProjects] = useState<number>(0);
    const [percentageFinancing, setPercentageFinancing] = useState<number>(0);
    useEffect(() => {
        const total = gaugeValues.potentialValue + gaugeValues.projectSum;
        const projectsPercentage = (gaugeValues.projectSum / total) * 100;
        const financingPercentage = (gaugeValues.potentialValue / total) * 100;
        setPercentageProjects(projectsPercentage);
        setPercentageFinancing(financingPercentage);
    }, [gaugeValues]);
    return (
        <div className="gauge-chart-container">
            <Typography.Title level={5} className="chart-title">
                Potencial do financiamento Mapeado
            </Typography.Title>
            <div className="select-container">
                <Select
                    className="select"
                    placeholder="Ano de análise"
                    allowClear
                    value={yearAnalysisSelected}
                    onChange={(value) => setYearAnalysisSelected(value)}
                >
                    {yearsAnalysis.map((year, index) => (
                        <Option key={index} value={year}>
                            {year}
                        </Option>
                    ))}
                </Select>
                <Select
                    className="select"
                    placeholder="Ano de Projeto"
                    allowClear
                    value={yearProjectsSelected}
                    onChange={(value) => setYearProjectsSelected(value)}
                >
                    {yearsProjects.map((year, index) => (
                        <Option key={index} value={year}>
                            {year}
                        </Option>
                    ))}
                </Select>
            </div>
            <div className="chart-wrapper">
                <div className="chart-bar-container">
                    <div
                        className="chart-bar chart-bar-projects"
                        style={{
                            height: `${percentageProjects}%`,
                            zIndex: percentageProjects >= percentageFinancing ? 2 : 1,
                        }}
                    >
                        <Typography.Text className="chart-bar-text">
                            {percentageProjects.toFixed(0)}%
                        </Typography.Text>
                    </div>
                    <div
                        className="chart-bar chart-bar-financing"
                        style={{
                            height: `${percentageFinancing}%`,
                            zIndex: percentageFinancing > percentageProjects ? 1 : 0,
                        }}
                    >
                        <Typography.Text className="chart-bar-text">
                            {percentageFinancing.toFixed(0)}%
                        </Typography.Text>
                    </div>
                </div>
                <div className="chart-info">
                    <div className="info-item-project">
                        <Typography.Text className="info-title-project">Valores de Projetos:</Typography.Text>
                        <Typography.Title level={2} className="info-value-project">
                            R$ {gaugeValues.projectSum.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </Typography.Title>
                    </div>
                    <div className="info-item-financing">
                        <Typography.Text className="info-title-financing">Potencial de Financiamento:</Typography.Text>
                        <Typography.Title level={2} className="info-value-financing">
                            R$ {gaugeValues.potentialValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </Typography.Title>
                    </div>
                </div>
            </div>
        </div>
    );
}